import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, Calendar, Moon } from 'lucide-react';
export function ProductDetails() {
  const features = ['The 7pm anchor (why it works and how to make it automatic)', '"Cooling defaults" you set once and use nightly', 'A dinner template that supports sleep stability (not dieting)', 'The 12-minute downshift sequence for tired brains', 'The exact schedule: Nights 1–3, 4–7, 8–14', "Travel/social night variations so real life doesn't blow it up"];
  return <section className="py-20 bg-white" data-id="element-159">
      <div className="max-w-6xl mx-auto px-4" data-id="element-160">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-161">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-162">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#2C2C2C]" data-id="element-163">
              Introducing: The 7pm Menopause Sleep Reset
            </h2>
            <p className="text-lg text-[#4A4A4A] mb-8" data-id="element-164">
              This is a <strong data-id="element-165">printable, step-by-step 14-night plan</strong>{' '}
              designed for women 55+ who want a nightly system—not a new hobby.
            </p>

            <div className="space-y-8" data-id="element-166">
              <div className="flex gap-4" data-id="element-167">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#F0EBE5] flex items-center justify-center text-[#FC8EAC]" data-id="element-168">
                  <FileText className="w-6 h-6" data-id="element-169" />
                </div>
                <div data-id="element-170">
                  <h3 className="text-xl font-bold mb-2" data-id="element-171">
                    1. The Full PDF Guide (14-Night Protocol)
                  </h3>
                  <ul className="space-y-2" data-id="element-172">
                    {features.map((feature, i) => <li key={i} className="flex items-start text-[#4A4A4A]" data-id="element-173">
                        <Check className="w-4 h-4 text-[#FC8EAC] mr-2 mt-1 flex-shrink-0" data-id="element-174" />
                        <span data-id="element-175">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-176">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#F0EBE5] flex items-center justify-center text-[#FC8EAC]" data-id="element-177">
                  <Calendar className="w-6 h-6" data-id="element-178" />
                </div>
                <div data-id="element-179">
                  <h3 className="text-xl font-bold mb-2" data-id="element-180">
                    2. Printable 14-Night Tracker
                  </h3>
                  <p className="text-[#4A4A4A]" data-id="element-181">
                    So you're not guessing. You'll see patterns quickly.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-182">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#F0EBE5] flex items-center justify-center text-[#FC8EAC]" data-id="element-183">
                  <Moon className="w-6 h-6" data-id="element-184" />
                </div>
                <div data-id="element-185">
                  <h3 className="text-xl font-bold mb-2" data-id="element-186">
                    3. The "3:07am Card"
                  </h3>
                  <p className="text-[#4A4A4A]" data-id="element-187">
                    A one-page rescue protocol for the moment you wake up—so you
                    don't turn one wake-up into a full night gone.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-188">
            {/* Abstract representation of the PDF/Product */}
            <div className="bg-[#F0EBE5] rounded-2xl p-8 md:p-12 shadow-xl border border-[#E5E0D8] relative overflow-hidden" data-id="element-189">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#FC8EAC]/10 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-190" />
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#FC8EAC]/10 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-191" />

              <div className="relative z-10 text-center border-2 border-[#2C2C2C] p-8 bg-white shadow-sm" data-id="element-192">
                <p className="text-sm uppercase tracking-widest text-[#FC8EAC] mb-2" data-id="element-193">
                  The Protocol
                </p>
                <h3 className="text-3xl font-serif font-bold text-[#2C2C2C] mb-4" data-id="element-194">
                  The 7pm Menopause
                  <br data-id="element-195" />
                  Sleep Reset
                </h3>
                <div className="w-12 h-1 bg-[#FC8EAC] mx-auto mb-4" data-id="element-196" />
                <p className="text-[#4A4A4A] italic" data-id="element-197">
                  A 14-Night System for Women 55+
                </p>
              </div>

              <div className="mt-6 flex justify-center gap-2" data-id="element-198">
                <div className="w-20 h-24 bg-white border border-[#E5E0D8] shadow-sm rounded-sm flex items-center justify-center" data-id="element-199">
                  <span className="text-[10px] text-gray-400" data-id="element-200">Tracker</span>
                </div>
                <div className="w-20 h-24 bg-[#2C2C2C] shadow-sm rounded-sm flex items-center justify-center" data-id="element-201">
                  <span className="text-[10px] text-white" data-id="element-202">Rescue Card</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}